import React from "react";
import { Menu, Button, List, ListItem, Divider } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../redux/root-reducer";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Person from "@material-ui/icons/PersonOutline";
import useStyles from "./HeaderUserbox.styles";
import globalStyles from "../../../theme/global.styles";
import { selectUserName } from "../../../redux/user/selectors";
import { logOutAction } from "../../../redux/user/actions";
import {faArrowRight, faArrowRightFromBracket} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

const HeaderUserbox: React.FC = () => {
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);
  const { user } = useSelector((state: RootState) => state.user);
  const history = useHistory();
  const classes = useStyles();
  const dispatch = useDispatch();
  const globalClasses = globalStyles();

  const userName = useSelector(selectUserName);
  const MAX_LEN = 20;
  const userNameShort = userName.length > MAX_LEN ? userName.slice(0, MAX_LEN - 3) + "..." : userName;

  const handleClick = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogOut = () => {
    handleClose();
    dispatch(logOutAction());
    history.push("/");
  };

  return (
    <>
      <Button
        onClick={handleClick}
        className={classes.item}
        startIcon={<Person color={"primary"} />}
        endIcon={<ExpandMoreIcon />}
      >
        <div className={`${globalClasses.fontWeightBold}`}>
          {userNameShort}
        </div>
      </Button>

      <Menu
        anchorEl={anchorEl}
        keepMounted
        getContentAnchorEl={null}
        open={Boolean(anchorEl)}
        anchorOrigin={{
          vertical: "center",
          horizontal: "center"
        }}
        transformOrigin={{
          vertical: "center",
          horizontal: "center"
        }}
        onClose={handleClose}
        MenuListProps={{ disablePadding: true }}
      >
        <div>
          <List style={{padding: 20}}>
            <ListItem
              className={classes.listItem}
              style={{paddingBottom: 0}}
              button
              onClick={() => {
                handleClose();
                history.push("/profil");
              }}
            >
              Uživatelský účet
              <FontAwesomeIcon className={globalClasses.btnIcon} icon={faArrowRight}/>
            </ListItem>
            <span className={globalClasses.textBlack50} style={{paddingLeft: 16}}>{user?.activeSubscription.level}</span>
            <Divider style={{marginTop: 20, marginLeft: 16, marginRight: 16}} />
            <ListItem
              className={classes.listItem}
              style={{paddingTop: 20}}
              button
              onClick={() => handleLogOut()}
            >
              <FontAwesomeIcon style={{marginRight: 10}} icon={faArrowRightFromBracket}/>
              Odhlásit se
            </ListItem>
          </List>
        </div>
      </Menu>
    </>
  );
};

export default HeaderUserbox;
